import { Injectable } from '@angular/core';

import { Vehicle } from '../../models/domain/Vehicle';
import { Consts } from '../../consts/consts';

@Injectable()
export class IconService {

	/**
	 * Path to directory with images
	 */
	private readonly IMG_FOLDER_DIR: string = '/assets/img/';


	/**
	 * Constructor of icon service
	 */
	public constructor() { }


	/**
	 * Returns url of icon according to status of a given vehicle
	 * @param vehicle vehicle
	 */
	public getIconStatusUrlForVehicle(vehicle: Vehicle): string {

		let filename: string;

		const vehicleSettings = Consts.VehicleSettingsByStatusMap.get(vehicle.St!);
		filename = vehicleSettings ? vehicleSettings.statusIconUrl : 'none.png';

		return this.IMG_FOLDER_DIR + filename;
	}

	public getClassStatusUrlForVehicle(vehicle: Vehicle): string {

		if (!vehicle) {
			return '';
		}

		const vehicleSettings = Consts.VehicleSettingsByStatusMap.get(vehicle.St!);
		return vehicleSettings ? vehicleSettings.statusClass : 'none';
	}

	public getETollStatusIconForVehicle(vehicle: Vehicle): string {

		if (!vehicle) {
			return '/assets/img/none';
		}

		return this.getETollStatusIconForStatus(vehicle.ES!);
	}

	public getETollStatusIconForStatus(status: number): string {
		const vehicleSettings = Consts.ETollStatusToIconMapping.get(status);
		return vehicleSettings ? vehicleSettings.iconUrl : '/assets/img/none';
	}
}
